import styled from 'styled-components';

const MyDiv = styled.div`
  position: relative; /* anchors the context-menu Portal + any absolute overlays */
  width: 100%;

  /* border-collapse: separate is required for sticky cells to render cleanly —
     with the default "collapse", adjacent cell borders can bleed through
     sticky/frozen columns while scrolling, which is part of what looked "fuzzy". */
  table {
    border-collapse: separate;
    border-spacing: 0;
  }

  /* Chakra's variant="striped" paints color directly on <td>, which is exactly
     why "inherit" didn't work for frozen cells (see code fix). This selector
     is just for the non-frozen, non-sticky cells — keep the visual striping
     consistent with the hardcoded colors used for frozen columns in JS
     (#FFFFFF / #F7FAFC) so both mechanisms produce identical results. */
  .chakra-table--striped tbody tr:nth-of-type(odd) td {
    background: #f7fafc;
  }

  /* Sticky header cells sit at top:0 with position:sticky — make sure the
     table's scrolling ancestor (TableContainer) doesn't clip them. */
  thead th {
    box-shadow: 0 1px 0 0 #e2e8f0; /* thin bottom divider so the header reads
                                       as a distinct band, not "floating" */
  }

  /* Column-resize handle: invisible until hover, avoids a constant visual
     seam running down every column when nobody's resizing. */
  th [role="group"] {
    position: relative;
  }

  /* Smoother horizontal scrollbar so dragging past frozen columns doesn't
     feel janky on Windows/Chrome (thin, branded). */
  .chakra-table-container {
    scrollbar-width: thin;
    scrollbar-color: #cbd5e0 transparent;

    &::-webkit-scrollbar {
      height: 8px;
      width: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #cbd5e0;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }

  /* Group header rows: full-width band, slightly indented chevron so nested
     rows read as "children" of the group visually. */
  tr[data-group-row="true"] td {
    border-top: 1px solid #c6f6d5;
    border-bottom: 1px solid #c6f6d5;
  }

  /* Drag-reorder affordance: while dragging a column header, the rest of the
     header row dims slightly so the drop target is obvious. */
  th[draggable="true"]:active {
    opacity: 0.85;
    cursor: grabbing;
  }
`;

export default MyDiv;